// Enrich the SDK's original pageview before it is queued; no additional capture.
function steepPosthogBeforeSend(event, win) {
  if (event?.event !== '$pageview') return event;
  try {
    win.SteepGrowthTracking?.syncPosthogContext?.();
    const context = win.SteepGrowthTracking?.eventContext?.() || {};
    const properties = {...event.properties, ...context};
    for (const field of ['landing_page','landing_session_id','landing_observed_at']) {
      if (!context[field]) delete properties[field];
    }
    return {...event, properties};
  } catch (_) { return event; }
}

// Existing Shopify visitor consent and SDK initialization stay unchanged.
function steepPosthogConsentController(initialize, win, doc) {
  if (win.__steepPosthogConsentGate) return;
  const gate = win.__steepPosthogConsentGate = {started:false, ready:false};
  const allowed = () => {
    try { return win.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch (_) { return false; }
  };
  const consentKnown = () => typeof win.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function';
  const sync = () => {
    if (!consentKnown()) return;
    if (!allowed()) {
      if (gate.ready) win.posthog?.opt_out_capturing?.();
      win.SteepGrowthTracking?.clearPosthogContext?.();
      return;
    }
    if (!gate.started) {
      gate.started = true;
      // Initialization must opt out by default. Recheck permission after SDK loading.
      initialize(() => {gate.ready = true; sync();});
    } else if (gate.ready) {
      win.posthog?.register?.(win.SteepGrowthTracking?.eventContext?.() || {});
      win.posthog?.opt_in_capturing?.({captureEventName:false});
      win.SteepGrowthTracking?.syncPosthogContext?.();
      for (const delay of [500,1500]) win.setTimeout(() => { if (allowed()) win.SteepGrowthTracking?.syncPosthogContext?.(); },delay);
    }
  };
  const load = () => {
    if (consentKnown()) {sync(); return;}
    win.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => {
      if (!error) sync();
    });
  };
  doc.addEventListener('visitorConsentCollected', sync);
  doc.addEventListener('DOMContentLoaded', load, {once:true});
  load();
}

steepPosthogConsentController(function (consentReady) {
!function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="Sn Cn init Hn Un Gn Yi zn Kn qn capture Vn kn calculateEventProperties es register register_once register_for_session unregister unregister_for_session os Bn ss getFeatureFlag getFeatureFlagPayload getFeatureFlagResult getAllFeatureFlags isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync ls identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset us shutdown setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty rs Xn createPersonProfile setInternalOrTestUser ns $n vs opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Jn debug tr At getPageViewId captureTraceFeedback captureTraceMetric Ln".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    posthog.init('phc_kZh23eUjEq3Fpv65oQYsnbL9rVnumXFiRvAfLGux83Kb', {
        api_host: 'https://t.steepyerba.com',
        ui_host: 'https://us.posthog.com',
        defaults: '2026-05-30',
        opt_out_capturing_by_default: true,
        opt_out_persistence_by_default: true,
        before_send: event => steepPosthogBeforeSend(event, window),
        loaded: function () {
          posthog.register(window.SteepGrowthTracking?.eventContext?.() || {});
          consentReady();
          posthog.onSessionId?.(() => window.SteepGrowthTracking?.syncPosthogContext?.());
        },
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    })

}, window, document);
